// theme.ts
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    background: string;
    text: string;
    icon: string;
    menuBackground: string;
    menuButton: string;
    menuIcon: string;
    menuHover: string;
    menuActive: string;
    backgroundCard: string;
    backgroundWordle: string;
    borderWordle: string;
    backgroundQuiz: string;
    backgroundRGBA: string;
    backgroundMenuButton: string;
    revealed: string;

    black: string;
    gray: string;
    white: string;
    red: string;
    green: string;
    purple: string;
    blue: string;
    smoothBlue: string;
    orange: string;
    nimbus: string;
    yellow: string;
  }
}

export const lightTheme: DefaultTheme = {
  background: '#ffffff',
  text: '#37352f',
  icon: '#37352f',
  menuBackground: '#f7f6f3',
  menuButton: '#111',
  menuIcon: '#e5e5e6',
  menuHover: '#e8e7e3',
  menuActive: '#d8d7d3',
  backgroundCard: '#f7f6f3',
  backgroundWordle: '#8c4e9a',
  borderWordle: 'rgba(114, 209, 254,1), rgba(134,79,151,1)',
  backgroundQuiz:
    'linear-gradient(to top right,rgba(134, 79, 151, 1), rgba(255, 180, 72, 1))',
  backgroundRGBA: 'rgba(255, 255, 255, 0.3)',
  backgroundMenuButton: '#D1A14C',
  revealed: '#fce3a6',

  black: '#111',
  gray: '#ccc',
  white: '#fafafa',
  red: '#dc3545',
  green: '#50915b',
  purple: '#7f4788',
  blue: '#2299ff',
  smoothBlue: '#9FA7F7',
  orange: '#bf9849',
  nimbus: '#CAD6FA',
  yellow: '#D1A14C',
};

export const darkTheme: DefaultTheme = {
  background: '#2f3437',
  text: '#e5e5e6',
  icon: '#e5e5e6',
  menuBackground: '#373c3f',
  menuButton: '#eee',
  menuIcon: '#37352f',
  menuHover: '#4b5053',
  menuActive: '#5b6063',
  backgroundCard: '#4f5b66',
  backgroundWordle: '#d8d8d8',
  borderWordle: 'rgba(134,79,151,1), rgba(255,180,72,1)',
  backgroundQuiz: '#2f3437',
  backgroundRGBA: 'rgba(0, 0, 0, 0.3)',
  backgroundMenuButton: '#7f4788',
  revealed: '#8a6d1f',

  black: '#111',
  gray: '#ccc',
  white: '#fafafa',
  red: '#dc3545',
  green: '#50915b',
  purple: '#7f4788',
  blue: '#2299ff',
  smoothBlue: '#484B6A',
  orange: '#bf9849',
  nimbus: '#696E7C',
  yellow: '#D1A14C',
};
